import { Pipe, PipeTransform } from '@angular/core';
import { catchError, isObservable, map, of, startWith } from 'rxjs';

@Pipe({
  name: 'obsWithLoading',
  standalone: true
})
export class ObsWithLoadingPipe implements PipeTransform {

  transform(val) {
    return isObservable(val)
      ? val.pipe(
        map((value: any) => ({ isLoading: false, value })),
        startWith({ isLoading: true }),
        catchError(error => of({ isLoading: false, error }))
      )
      : val;
  }

}
